import { AppState as State } from '@ducks/index';

export const getRefreshId = (state: State) => state.tag.refresh;
export const getTags = (state: State) => state.tag.tags;
export const getTagSettingList = (state: State) => state.tag.tagSettingList;
export const checkIsLoading = (state: State) => state.tag.isLoading;
export const checkIsSubmitting = (state: State) => state.tag.isSubmitting;
